import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";
import {
  IProjectBudget,
  IProjectBudgetHistoryPage,
  IProjectBudgetResponse,
} from "../../../@types/project/project-budget.type";

export const addOrUpdateProjectBudget = async (budget: IProjectBudget) => {
  try {
    const { data } = await Api.post(
      "/api/ProjectBudget/AddOrUpdateProjectBudget",
      budget
    );
    return data;
  } catch (error) {
    const message = 'Erro ao criar ou atualizar orçamento do Projeto';
    throw new ApiException(getErrorMessage(error, message));
  }
};

export const getProjectBudgetHistory = async (
  projectId: string,
  skip: number,
  take: number,
): Promise<IApiResponse<IProjectBudgetHistoryPage> | ApiException> => {
  try {
    const { data } = await Api.get<IApiResponse<IProjectBudgetHistoryPage>>(
      `/api/ProjectBudgetHistory/GetProjectBudgetHistory?id=${projectId}&skip=${skip}&take=${take}`
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'));
  }
};

export const getProjectBudgetsByProjectId = async (
  projectId: string
): Promise<IApiResponse<IProjectBudgetResponse> | ApiException> => {
  try {
    const { data } = await Api.get<IApiResponse<IProjectBudgetResponse>>(
      `/api/ProjectBudget/GetProjectBudgetsByProjectId/${projectId}`
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'));
  }
};

export const getProjectBudgetsById = async (
  id: string
): Promise<IApiResponse<IProjectBudget> | ApiException> => {
  try {
    const { data } = await Api.get<IApiResponse<IProjectBudget>>(
      `/api/ProjectBudget/GetProjectBudgetById/${id}`
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'));
  }
};

export const importProjectBudgetFromExcel = async (
  projectId: string,
  userId: string,
  formData: FormData
) => {
  try {
    const { data } = await Api.post(
      `/api/Excel/ImportProjectBudgetFromExcel?projectId=${projectId}&userId=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os dados do Projeto'));
  }
};
